import type { IconProps } from "./icon-types";

/**
 * LogOut 공용 UI glyph.
 *
 * Lucide의 `LuLogOut` geometry를 정적 SVG로 인라인 — c6 패키지는 외부 아이콘
 * 라이브러리를 런타임 의존하지 않는다(RFC-design-system-split §아이콘).
 */
export const LogOutIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" x2="9" y1="12" y2="12" />
  </svg>
);
